import {Button, message, Modal, Space, Table, Typography} from "antd";
import React, {useEffect, useState} from "react";
import Api from "../common/Api";

interface Props {
    refresh: number;
}

const {Text} = Typography;

const {Column} = Table;

const DeleteMessage = (props: { group: string }) => {
    return (
        <>
            <Text>Are you sure you want to delete </Text>
            <Text strong>{props.group}</Text><Text> group permanently ?</Text><br/><br/>
            <Text strong>You can't undo this action, </Text>
            <Text>to confirm deletion, press</Text> <Text strong>Confirm</Text>
        </>
    )
}


const GroupList = (props: Props) => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [localRefresh, setLocalRefresh] = useState(0);

    useEffect(() => {
        (async () => {
            setLoading(true)
            const {data} = await Api.groupsManagement.getGroups()
            setGroups(data)
            setLoading(false)
        })();
    }, [props.refresh, localRefresh])

    const confirmAction = (group: string) => {
        const base = {
            okText: 'Confirm',
            cancelText: 'Cancel',
            title: 'Delete group',
            content: <DeleteMessage group={group}/>,
            onOk: async () => {
                try {
                    await Api.groupsManagement.deleteGroup(group)
                    message.success("Group deleted!");
                    setLocalRefresh(localRefresh + 1)
                } catch (e) {
                    message.error("Error while deleting group");
                    throw (e)
                }
            }
        }
        Modal.confirm(base);
    }


    return (
        <Table dataSource={groups} loading={loading}>
            <Column title="Group name" key="username"/>
            <Column
                title="Action"
                key="action"
                render={(_, record: string) => (
                    <Space size="middle">
                        <Button type="link" onClick={() => {
                            confirmAction(record)
                        }}>Delete</Button>
                    </Space>
                )}
            />
        </Table>
    )
}

export default GroupList;
